import { Injectable } from '@angular/core';
import { Http, Response, Headers, URLSearchParams, RequestOptions, RequestMethod } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class BackgroundCheckService {
    headers: Headers;
    options: RequestOptions;
    baseAPIurl: string = '';

    constructor(private _http: Http, private _httpClient: HttpClient) {
        this.headers = new Headers({ 'Content-Type': 'application/json' });
        this.options = new RequestOptions({ headers: this.headers });
        this.baseAPIurl = environment.baseAPIUrl;
    }

    GetHeader() {
        let newHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
        return newHeaders;
    }



    InsertBackgroundVerifyInfo(VerifyIdentityBackground) {
        return this._http.post(this.baseAPIurl + "BackgroundCheck/InsertBackgroundVerifyInfo", VerifyIdentityBackground, this.options);
    }

    GetState() {
        return this._http.get(this.baseAPIurl + "BackgroundCheck/GetState", this.options)

    }

    OrderSummary(PackageId: number): Observable<any> {
        return this._httpClient.get(this.baseAPIurl + "BackgroundCheck/OrderSummary?PackageId=" + PackageId)
            .pipe(
                catchError(this.handleError)
            );
    }

    UpdatePassword(Email: string, Password: string): Observable<any> {
        return this._httpClient.get(this.baseAPIurl + "BackgroundCheck/UpdatePassword?Email=" + Email + '&Password=' + Password)
            .pipe(
                catchError(this.handleError)
            );
    }

    private handleError(error: Response) {
        return Observable.throw(error.json().error || 'Server error');
    }

    VerifyMessageForRunBackgroundCheck(Id: string): Observable<any> {
        return this._httpClient.get(this.baseAPIurl + "BackgroundCheck/VerifyMessageForRunBackgroundCheck?Id=" + Id)
            .pipe(
                catchError(this.handleError)
            );
    }


    IsEMailIdExit(EmailId: string, Id: number): Observable<any> {
        return this._httpClient.get(this.baseAPIurl + "BackgroundCheck/IsEMailIdExit?EmailId=" + EmailId + '&Id=' + Id, { headers: this.GetHeader() })
            .pipe(
                catchError(this.handleError)
            );
    }

    SubmitPersonSelectedServices(UserSelectedServices): Observable<any> {
        return this._httpClient.post(this.baseAPIurl + "BackgroundCheck/SubmitPersonSelectedServices", UserSelectedServices, { headers: this.GetHeader() })
            .pipe(
                catchError(this.handleError)
            );
    }

    Payment(PaymentDetails): Observable<any> {
        return this._httpClient.post(this.baseAPIurl + 'BackgroundCheck/Payment',
            PaymentDetails, { headers: this.GetHeader() })
            .pipe(
                catchError(this.handleError)
            );
    }

    IsUserFollowAllSettingStep(EmailId: string, Password: string) {
        return this._httpClient.get(this.baseAPIurl +
            'BackgroundCheck/IsUserFollowAllSettingStep?EmailId=' + EmailId + '&Password=' + Password, { headers: this.GetHeader() })
            .pipe(
                catchError(this.handleError)
            );
    }

    GetUserSettingDetails(EmailId: string): Observable<any> {
        return this._httpClient.get(this.baseAPIurl + 'BackgroundCheck/GetUserSettingDetails?EmailId=' + EmailId, { headers: this.GetHeader() })
            .pipe(
                catchError(this.handleError)
            );
    }


    InsertIntoUserJuridictions(EmailId, Juridiction, IsAddressJuridiction, City,
        State, Zip) {
        return this._httpClient.get(this.baseAPIurl +
            'BackgroundCheck/InsertIntoUserJuridictions?EmailId=' + EmailId + '&Juridiction=' + Juridiction + '&IsAddressJuridiction=' + IsAddressJuridiction + '&City=' + City + '&State=' + State + '&Zip=' + Zip, { headers: this.GetHeader() })
            .pipe(
                catchError(this.handleError)
            );
    }


    GetPackageRefernceId(PackageId: number): Observable<any> {
        return this._httpClient.get(this.baseAPIurl + 'BackgroundCheck/GetPackageRefernceId?PackageId=' + PackageId, {
            headers: this.GetHeader()
        }).pipe(
            catchError(this.handleError)
        )
    }

    AddNewTransaction(nTransType, nSearchId, nServiceId) {
        return this._httpClient.get(this.baseAPIurl + 'BackgroundCheck/AddNewTransaction?nTransType=' + nTransType + '&nSearchId=' + nSearchId + '&nServiceId=' + nServiceId, {
            headers: this.GetHeader()
        }).pipe(
            catchError(this.handleError)
        )
    }

    UpdateFeeApproval(Status, Email, RequestId) {
        return this._httpClient.get(this.baseAPIurl + 'BackgroundCheck/UpdateFeeApproval?Status=' +
            Status + '&Email=' + Email + '&RequestId=' + RequestId, {
                headers: this.GetHeader()
            }).pipe(
                catchError(this.handleError)
            )
    }

    GetFeeApprovalDetails(RequestId) {
        return this._httpClient.get(this.baseAPIurl + 'BackgroundCheck/GetFeeApprovalDetails?RequestId=' +
            RequestId, {
                headers: this.GetHeader()
            }).pipe(
                catchError(this.handleError)
            )
    }

    SendEmailForSubmittedUserInFeeApproval(EmailId, Status, ServiceDetails) {
        return this._httpClient.get(this.baseAPIurl + 'IdentityMail/SendEmailForSubmittedUserInFeeApproval?EmailId=' +
            EmailId + '&Status=' + Status + '&ServiceDetails=' + ServiceDetails, {
                headers: this.GetHeader()
            }).pipe(
                catchError(this.handleError)
            )
    }


};